import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { resizeParent, loadStylesheet } from '../../services/Utils'

import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import { RRule, RRuleSet, rrulestr } from 'rrule';



// Components
import Spinner from '../Spinner';
import { Modal } from '../Modal';
import Portal from '../Portal';

// Redux
import { configure, getConfiguration } from '../../actions/Settings'
import { getEpisodes, getPCOCalendarEvents } from '../../actions/Events';

const localizer = momentLocalizer(moment)

const stringToDate = (str) => {
    const year = str.substr(0, 4)
    const month = str.substr(4, 2)
    const date = str.substr(6, 2)

    return year + '-' + month + '-' + date;
}

const transformEvent = (item) => {
    const FORMAT = "YYYY ddd MMM DD HH:mm";

    let formatted = {};
    formatted.title = item.title;
    formatted.allDay = false;


    if (!item.meta.start_date) return null;

    // Require End Time:
    if (!item.meta.start_time) item.meta.start_time = '00:00:00';


    let start = stringToDate(item.meta.start_date);
    if (item.meta.start_time != '') start += 'T' + item.meta.start_time;

    let end;
    if (item.meta.end_date) end = stringToDate(item.meta.end_date);

    if (item.meta.end_date && item.meta.end_time) {
        end = end + 'T' + item.meta.end_time
    }
    else if (!item.meta.end_date && item.meta.end_time) {
        end = stringToDate(item.meta.start_date) + 'T' + item.meta.end_time;
    }
    // else if(item.meta.end_date && !item.meta.end_time) {
    //     end = item.meta.end_date;
    //     console.log("-- Has Only End Date")
    // }
    else {

        // No End Date Defined
        end = moment(start).add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss');
    }

    formatted.start = new Date(start);
    formatted.end = new Date(end);
    formatted.url = item.url;
    formatted.id = item.ID + Math.random();
    formatted.date = item.pretty_date.string;
    formatted.rrule = item.rrule;
    formatted.startTimestamp = moment(start).unix();
    formatted.endTimestamp = moment(end).unix();
    formatted.description = item.content;
    return formatted;
}

const transformPCOCalendarEvent = (item) => {
    const FORMAT = "YYYY ddd MMM DD HH:mm";

    let formatted = {};
    formatted.title = item.Event.name;
    formatted.allDay = (item.Instance.all_day_event) ? item.Instance.all_day_event : false;


    let start = item.starts_at;
    let end;
    if (item.ends_at) end = item.ends_at;
    else end = moment(start).add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss');

    formatted.start = new Date(start);
    formatted.end = new Date(end);
    formatted.url = item.Instance.church_center_url;
    formatted.id = item.event_id + Math.random();
    formatted.date = moment(start).format('YYYY-MM-DD HH:mm');
    // formatted.rrule = item.rrule;
    formatted.startTimestamp = moment(start).unix();
    formatted.endTimestamp = moment(end).unix();
    formatted.description = item.Instance.recurrence_description;
    return formatted;
}


const generateRecurring = (formattedEvents) => {
    let withRecurringEvents = [];

    formattedEvents.map(event => {
        const thisEvent = (event.start) ? event : transformEvent(event);

        // Add Recurring
        if (thisEvent.rrule) {


            // Get Recurring Rules
            const rule = rrulestr(event.rrule);

            // One Year Worth 
            var oneYearFromNow = new Date();
            oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

            // Create Instances
            const instances = rule.between(new Date(), oneYearFromNow);
            var i = 0;
            const eventInstances = instances.map(eventInstance => {
                i++;
                const clonedEvents = {};
                clonedEvents.title = thisEvent.title;
                clonedEvents.allDay = false;
                clonedEvents.start = moment(eventInstance).format('YYYY-MM-DTHH:mm:ss');
                clonedEvents.end = moment(eventInstance).add(2, 'hours').format('YYYY-MM-DTHH:mm:ss');
                clonedEvents.url = thisEvent.url;
                clonedEvents.id = thisEvent.id + '-' + i;
                clonedEvents.date = moment(eventInstance).format('MMMM D YYYY');
                clonedEvents.startTimestamp = moment(eventInstance).unix();
                clonedEvents.description = thisEvent.content;
                withRecurringEvents.push(clonedEvents);
            })



        }

        withRecurringEvents.push(thisEvent);
    })

    // Sort Array By Start Date
    withRecurringEvents.sort(function (a, b) { return a.startTimestamp - b.startTimestamp; });

    // Return with recurring
    return withRecurringEvents;
}


export const TCCCalendar = ({ site, display, theme, category, ics, type = null }) => {

    // Default State
    const dispatch = useDispatch();
    const [containerClassName, setContainerClassName] = useState('loading')
    const [calendarView, setCalendarView] = useState('month')
    const [openModal, setOpenModal] = useState(false);
    const [activeEvent, setActiveEvent] = useState(null);

    // Store
    const fullSettings = useSelector(state => state.Settings)
    const fullEvents = useSelector(state => state.Events);


    // ----------------------------
    // Effects
    // ----------------------------

    // On Mount
    useEffect(() => {

        // Add Style Sheet
        loadStylesheet('tccCalendarCSS', `${site}/wp-content/plugins/thechurchco/components/web-components/assets/react-big-calendar.css`)

        // Configure
        dispatch(configure(site))

        // Load Configuration
        dispatch(getConfiguration());

        // Get Podcasts
        if (type !== 'pcocalendar') dispatch(getEpisodes(null, null, category, 'all', ics));
        else dispatch(getPCOCalendarEvents(null, null, category, 'all', ics));

        resizeParent();

    }, [])

    useEffect(() => {
        resizeParent();
    }, [fullEvents])


    // ----------------------------
    // Interaction
    // ----------------------------

    const onEventSelect = (item, e) => {
        if (!item.url) {
            setOpenModal(true);
            setActiveEvent(item);
            return;
        }
        window.location.href = item.url;
    }

    // ----------------------------
    // Render
    // ----------------------------

    const renderCalendar = () => {

        // Loader
        if (fullEvents.ui === 'loading' || !fullEvents.events) return (<div className="loading"><Spinner /></div>);

        // Format
        let cleanEvents;
        let formattedEvents;
        if (type !== 'pcocalendar') {
            cleanEvents = fullEvents.events.map(item => transformEvent(item))
            formattedEvents = generateRecurring(cleanEvents);
        } else {
            formattedEvents = fullEvents.events.map(item => transformPCOCalendarEvent(item))
        }

        // Calendar
        return (
            <Calendar
                localizer={localizer}
                events={formattedEvents}
                startAccessor="start"
                endAccessor="end"
                view={calendarView}
                views={['month', 'week', 'day']}
                onView={(v) => setCalendarView(v)}
                style={{ height: 1000 }}
                onSelectEvent={onEventSelect}
            />
        )


    }

    const renderList = () => {
        // Loader
        if (fullEvents.ui === 'loading' || !fullEvents.events) return (<div className="loading"><Spinner /></div>);

        if (type === 'pcocalendar') return renderPCOCalendarList();

        // Format
        const filteredEvents = fullEvents.events.filter(item => {
            const f = (item.start) ? item : transformEvent(item);
            // const f = transformEvent(item);
            const r = moment(f.start).isSameOrAfter(moment())
            if (r === true) return f;
        })

        const formattedEvents = generateRecurring(filteredEvents);

        if (formattedEvents.length <= 0) return (<div className="list-container"></div>)

        // Calendar
        return (
            <div className="list-container">
                {formattedEvents.map(item => {
                    const f = (item.start) ? item : transformEvent(item);
                    return (
                        <div className="list-event" key={f.id} onClick={() => onEventSelect(f)}>
                            <b className="list-event-title">{f.title}</b>
                            <span className="list-event-date">{f.date}</span>
                        </div>
                    )
                })}
            </div>
        )
    }

    const renderPCOCalendarList = () => {
        return (
            <div className="list-container">
                {fullEvents.events.map(item => {
                    const f = (item.start) ? item : transformPCOCalendarEvent(item);
                    return (
                        <div className="list-event" key={f.id} onClick={() => onEventSelect(f)}>
                            <b className="list-event-title">{f.title}</b>
                            <span className="list-event-date">{f.date}</span>
                        </div>
                    )
                })}

            </div>
        )
    }


    // Main
    var forceStyles = (display === 'feed') ? { display: 'block' } : {};

    return (
        <div className={containerClassName}>
            {display !== 'feed' && (<div className="calendar">{renderCalendar()}</div>)}
            <div className="calendar-list" style={forceStyles}>{renderList()}</div>
            <Portal selector='body' insertBefore="true">
                <Modal open={openModal} onClose={() => setOpenModal(false)} className="-centered">
                    {activeEvent && (<div className="row lightbg in-view">
                        <div className="row-defaults">
                            <h3 className="row-title">{activeEvent.title}</h3>
                            <div className="row-subtitle">{activeEvent.date}</div>
                            <div className="row-text" dangerouslySetInnerHTML={{ __html: activeEvent.description }} />
                        </div>
                    </div>)}
                </Modal>
            </Portal>
        </div>
    )
}